<template>
  <v-skeleton-loader
    type="button"
    class="home-admin-button-skeleton"
    width="110px"
  />
</template>

<style lang="less" scoped>
.home-admin-button-skeleton {
  margin-top: 55px;

  &:deep(.v-skeleton-loader__bone) {
    width: 110px;
  }

  &:deep(.v-skeleton-loader__button) {
    max-width: 110px;
    border-radius: 28px;
    margin: 0;
  }
}
</style>
